import { render, staticRenderFns } from "./State.vue?vue&type=template&id=87db548e"
import script from "./State.vue?vue&type=script&lang=js"
export * from "./State.vue?vue&type=script&lang=js"
import style0 from "./State.vue?vue&type=style&index=0&id=87db548e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports